import BaseRemote from './baseRemote'

const instance = new BaseRemote(process.env.REACT_APP_OIDC_ISSUER)

export class PorticoRemote {
  static getPusherInfo = () => {
    const response = instance.get('/pusher/info', {})
    return response
  }
}

export default PorticoRemote
